export const CLIENT_TYPES = {
  INDIVIDUAL: 'individual',
  COMPANY: 'company'
};

export const ENTRY_CHANNELS = {
  COMMERCIAL: 'commercial',
  SOCIAL_MEDIA: 'social_media',
  WORD_OF_MOUTH: 'word_of_mouth',
  WEB: 'web',
  EPC: 'epc'
};

export const ENTRY_CHANNEL_LABELS = {
  commercial: 'Comercial',
  social_media: 'Redes Sociales',
  word_of_mouth: 'Boca a Boca',
  web: 'Web',
  epc: 'EPC'
};

export const CLIENT_TAGS = {
  CAMBIO_COMERCIALIZADORA: 'cambio_comercializadora',
  FOTOVOLTAICA: 'fotovoltaica',
  CARGADOR_ELECTRICO: 'cargador_electrico'
};

export const CLIENT_TAG_LABELS = {
  cambio_comercializadora: 'Cambio de comercializadora',
  fotovoltaica: 'Fotovoltaica',
  cargador_electrico: 'Cargador eléctrico'
};

export const createClient = (data) => ({
  id: '',
  type: data.type || CLIENT_TYPES.INDIVIDUAL,
  
  // Tags
  tags: data.tags || [],
  
  // Datos comunes
  email: data.email || '',
  phone: data.phone || '',
  iban: data.iban || '',
  
  // Persona física
  firstName: data.firstName || '',
  lastName: data.lastName || '',
  dni: data.dni || '',

  contactName: data.contactName || '',
  
  // Empresa
  companyName: data.companyName || '',
  taxId: data.taxId || '',
  representativeId: data.representativeId || '',
  representativeName: data.representativeName || '',
  representativePhone: data.representativePhone || '',
  representativeEmail: data.representativeEmail || '',
  representativeDni: data.representativeDni || '',
  
  // Direcciones (cada una con su CUPS, CUPS Gas, referencia catastral, notas y factura)
  addresses: data.addresses || [{
    street: data.address?.street || '',
    city: data.address?.city || '',
    state: data.address?.state || '',
    zipCode: data.address?.zipCode || '',
    country: data.address?.country || 'España',
    cups: data.cups || '',
    cupsGas: data.cupsGas || '',
    referenciaCatastral: data.referenciaCatastral || '',
    notes: '',
    hasInvoice: data.hasInvoice || false,
    invoiceLink: data.invoiceLink || ''
  }],
  
  // Mantener compatibilidad con datos antiguos
  address: data.address || {
    street: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'España'
  },
  cups: data.cups || '',
  cupsGas: data.cupsGas || '',
  referenciaCatastral: data.referenciaCatastral || '',
  hasInvoice: data.hasInvoice || false,
  invoiceLink: data.invoiceLink || '',
  
  files: data.files || [],
  
  // Canal de entrada
  entryChannel: data.entryChannel || ENTRY_CHANNELS.WEB,
  entryChannelContactId: data.entryChannelContactId || '',
  
  // Metadata
  notes: data.notes || '',
  assignedTo: '',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: '',
  isActive: true
});

export const clientSchema = {
  type: CLIENT_TYPES.INDIVIDUAL,
  tags: [],
  email: '',
  phone: '',
  iban: '',
  firstName: '',
  lastName: '',
  dni: '',
  companyName: '',
  taxId: '',
  representativeId: '',
  representativeName: '',
  representativePhone: '',
  representativeEmail: '',
  representativeDni: '',
  addresses: [{
    street: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'España',
    cups: '',
    cupsGas: '',
    referenciaCatastral: '',
    notes: '',
    hasInvoice: false,
    invoiceLink: ''
  }],
  address: {
    street: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'España'
  },
  cups: '',
  cupsGas: '',
  referenciaCatastral: '',
  hasInvoice: false,
  invoiceLink: '',
  files: [],
  entryChannel: ENTRY_CHANNELS.WEB,
  entryChannelContactId: '',
  notes: '',
  assignedTo: '',
  isActive: true
};